import React from 'react';
import { Layout } from 'antd';
import authStyles from './AuthLayout.module.scss';
import { inject, provider } from 'react-ioc';
import { UIStore, SchoolStore } from 'stores';
import { observer } from 'mobx-react';
import SchoolLogo from 'App/SchoolLogo/SchoolLogo';
import { Outlet } from 'react-router-dom';
import { Localization } from '@axl/accel-framework/utils';
import { AccelLogo } from '@axl/accel-framework/components';
import AuthStore from 'views/auth/stores/AuthStore';

@observer
@provider(AuthStore)
export default class AuthLayout extends React.Component {
    @inject(SchoolStore) school: SchoolStore;
    @inject(UIStore) uiStore: UIStore;
    @inject(Localization) loc: Localization;

    render() {
        return <Layout id='auth_layout'>
            <div className={`${authStyles.auth_layout} login-wrapper`}>
                <div className={authStyles.auth_drawer} style={{ width: this.uiStore.deviceSize == "desktop" ? "450px" : "100%" }}>
                    <div className={authStyles.auth_form_wrapper}>
                        <div className={authStyles.auth_form_wrapper_header}>
                            <div className={`login-logo`}>

                                <SchoolLogo theme='dark' height={100} imageClassname='mb-30' />

                            </div>
                            <h1 className={`${authStyles.school_name} login-school-name`} >
                                {this.school.school.name}
                            </h1>
                        </div>
                        <div className={`${authStyles.auth_form_wrapper_body} login-content`}>
                            <Outlet />
                        </div>
                        <div className='flex flex-col align-center'>
                            <span className='fw-500'>{this.loc.word('School.poweredByLabel', { default: 'Powered by' })}</span>
                            <a href='https://axl.tech' target='_blank' data-testid='axl-link'>
                                <AccelLogo theme='dark' width={70} height={50} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>;
    }
}